import { render, staticRenderFns } from "./DownLoad.vue?vue&type=template&id=77a495cc&scoped=true"
import script from "./DownLoad.vue?vue&type=script&lang=js"
export * from "./DownLoad.vue?vue&type=script&lang=js"
import style0 from "./DownLoad.vue?vue&type=style&index=0&id=77a495cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a495cc",
  null
  
)

export default component.exports